import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === '/';

  const navItems = [
    { label: 'INÍCIO', href: onHome ? '#home' : '/#home' },
    { label: 'DESTINOS', href: onHome ? '#destinations' : '/#destinations' },
    { label: 'SOBRE', href: onHome ? '#corporate' : '/#corporate' },
    { label: 'CONTATO', href: onHome ? '#contact' : '/#contact' },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-border shadow-sm">
      <div className="container">
        <div className="flex items-center justify-between h-20 md:h-24">
          <Link to="/" className="flex items-center hover:scale-105 transition-transform duration-300 -my-2">
            <Logo className="h-20 md:h-28" />
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a key={item.label} href={item.href} className="text-foreground hover:text-accent transition-colors duration-300 font-semibold text-sm tracking-wide">
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:block">
            <a href="https://wa.me/5548991904829?text=Olá! Gostaria de solicitar um orçamento para uma viagem." target="_blank" rel="noopener noreferrer" className="btn-primary no-underline inline-block">
              Solicitar Orçamento
            </a>
          </div>

          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 hover:bg-secondary rounded-lg transition-colors ml-auto" aria-label="Menu">
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden pb-4 space-y-2 fade-in-down">
            {navItems.map((item) => (
              <a key={item.label} href={item.href} className="block px-4 py-2 text-foreground hover:bg-secondary rounded-lg transition-colors font-semibold" onClick={() => setIsMenuOpen(false)}>
                {item.label}
              </a>
            ))}
            <a href="https://wa.me/5548991904829?text=Olá! Gostaria de solicitar um orçamento para uma viagem." target="_blank" rel="noopener noreferrer" className="w-full btn-primary mt-3 no-underline block text-center">
              Solicitar Orçamento
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}
